import {
  AD_DISPLAYS,
  API_TYPES, BETTING_ZONE_API_TYPES,
  ENVIRONMENTS,
  SITE_DOMAINS,
  TERMINATOR as SEO_PROMORTION_LINKS,
  TERMINATOR,
  WIDGET_TYPES
} from "../../consts";
import {ARGS} from "../args";
import {BootstrapSettings} from "./bootstrap-settings";
import {BaseModel} from "../../../infrastructure/models/base-model";
import {singleton} from "../../../infrastructure/decorators/singleton";

@singleton
export class SiteConfig extends BaseModel {
  rootApi: String;
  dataApi: String;
  imagesApi: String;
  apiType: API_TYPES;
  terminatorEnvType: TERMINATOR.ENV_TYPES;
  splEnvType: SEO_PROMORTION_LINKS.ENV_TYPES;
  env: ENVIRONMENTS;
  isDevMode: Boolean;
  partnerModel;
  applicationStartTime: Number;

  static injectables = [];

  constructor() {
    super();

    this.env = ARGS.NODE_ENV;
    this.isDevMode = this.env === ENVIRONMENTS.dev;
    this.isProduction = ARGS.PRODUCTION_TYPE === 'production';
  }

  init(params: BootstrapSettings, partnerModel, apiType: API_TYPES, terminatorEnvType: TERMINATOR.ENV_TYPES, splEnvType: SEO_PROMORTION_LINKS.ENV_TYPES, adDisplay: AD_DISPLAYS.default, bettingZoneApi: BETTING_ZONE_API_TYPES = BETTING_ZONE_API_TYPES.prod) {
    this.apiType = apiType;
    this.bettingZoneApiType = bettingZoneApi;
    this.terminatorEnvType = terminatorEnvType;
    this.splEnvType = splEnvType;
    this.adDisplay = adDisplay;
    this.imagesApi = ARGS.IMAGES_API;
    this.rootApi = `https://${this.apiType}.${SITE_DOMAINS.default}`;
    this.dataApi = `${this.rootApi}/${ARGS.WEBSITE_DEFAULT_POSTFIX}`;
    this.bettingZoneApi = `https://${this.bettingZoneApi}.wpenginepowered.com`;
    this.partnerModel = partnerModel;
    this.applicationStartTime = params.applicationStartTime;
    this.widgetType = params.widgetType;
  }

  get isWidget(): Boolean {
    return this.widgetType !== WIDGET_TYPES.website;
  }
}
